import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {UserModel} from './user.model';
import {PaginatedResponseModel} from '../../models/paginated.response.model';
import {UserCreateModel} from './user.create.model';
import {UserPasswordModel} from './user.password.model';
import {PaycardStatusEnum} from '../paycard/paycard.status.enum';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private http: HttpClient) { }

  getCurrent(): Observable<UserModel> {
    return this.http.get<UserModel>(`/v2/admin/currentUser`);
  }

  getByUsername(userName: string): Observable<UserModel> {
    return this.http.get<UserModel>(`/v2/admin/user/${userName}`);
  }

  getPaginated(page: number, size: number, userName: string): Observable<PaginatedResponseModel<UserModel>> {
    const params: {
      page: string,
      size: string,
      userName?: string
    } = {
      page: page.toString(),
      size: size.toString(),
    };
    if (userName) { params.userName = userName; }

    return this.http.get<PaginatedResponseModel<UserModel>>(`/v2/admin/user`, { params });
  }

  create(user: UserCreateModel): Observable<UserModel> {
    return this.http.post<UserModel>(`/v2/admin/user`, user);
  }

  delete(userName: string): Observable<void> {
    return this.http.delete<void>(`/v2/admin/user/${userName}`);
  }

  update(user: UserModel, userName: string): Observable<UserModel> {
    return this.http.put<UserModel>(`/v2/admin/user/${userName}`, user);
  }

  updatePassword(password: UserPasswordModel, userName: string): Observable<UserModel> {
    return this.http.put<UserModel>(`/v2/admin/user/password/${userName}`, password);
  }

  updateCurrent(user: UserModel): Observable<UserModel> {
    return this.http.put<UserModel>(`/v2/admin/user`, user);
  }

  updateCurrentPassword(password: UserPasswordModel): Observable<UserModel> {
    return this.http.put<UserModel>(`/v2/admin/user/password`, password);
  }
}
